import React, { useState } from 'react';
import '../styles/Login.css';
import CreateAccount from './CreateAccount';
import logoIcon from '../assets/Branding/B&M_Logo/logo_icon.png';

const Login = () => {
  const [showCreateAccount, setShowCreateAccount] = useState(false);

  if (showCreateAccount) {
    return <CreateAccount onBackToLogin={() => setShowCreateAccount(false)} />;
  }

  return (
    <div className="login-container">
      <img src={logoIcon} alt="Bubble & Maple" className="login-logo" />
      <h2>Login</h2>
      <form className="login-form">
        <div className="form-group">
          <input 
            type="email" 
            placeholder="Email" 
            className="form-input"
          />
        </div>
        <div className="form-group">
          <input 
            type="password" 
            placeholder="Password" 
            className="form-input"
          />
        </div>
        <div className="form-group">
          <a href="#" className="forgot-password">
            Forgot your password?
          </a>
        </div>
        <div className="form-actions">
          <button type="submit" className="btn btn-primary">
            Sign In
          </button>
          <button 
            type="button" 
            className="btn btn-secondary"
            onClick={() => setShowCreateAccount(true)}
          >
            Create account
          </button>
        </div>
      </form>
    </div>
  );
};

export default Login; 